type NODE_ENV = typeof process.env.NODE_ENV;

const FEATURES = {
    "profile-page": ["test", "development", "staging"],
    "disable-submit-button": ["production"],
    "session-modal": ["test", "staging", "development", "production"],
};

export default FEATURES;
